import { render, staticRenderFns } from "./reactivate-popup.vue?vue&type=template&id=639cb779&scoped=true&"
import script from "./reactivate-popup.vue?vue&type=script&lang=js&"
export * from "./reactivate-popup.vue?vue&type=script&lang=js&"
import style0 from "./reactivate-popup.vue?vue&type=style&index=0&id=639cb779&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639cb779",
  null
  
)

component.options.__file = "reactivate-popup.vue"
export default component.exports